import { useState, useEffect } from 'react';
import { getSalesAnalysis } from '../../api/sales';

const useSalesAnalysisList = (storeId, year) => {
  const [salesAnalysisData, setSalesAnalysisData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!storeId || !year) {
      setSalesAnalysisData([]);
      setLoading(false);
      return;
    }
    setLoading(true);
    const fetchData = async () => {
      try {
        const data = await getSalesAnalysis(storeId, year);
        setSalesAnalysisData(data);
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [storeId, year]);

  return { salesAnalysisData, loading, error };
};

export default useSalesAnalysisList;
